import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
import _ from "lodash";
import { fontStringify } from "pdfmake/src/helpers.js";
export default class transferTicket {
  constructor() { }

  static getDocData(mainData) {
    /*let tenderTable = this.getTenderTable(contadores, mPagos)
    let familiasTable = this.getFamiliasTable(familias);
    let otrosTable = this.getOtrosTable(contadores, mPagos)*/
    let getTable = this.getTable(mainData.groupedData);

    /*let imgColumn = {
        text: "",
        width: "10%",
    };*/
    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      pageOrientation: "portrait",
      pageSize: {
        width: 500,
        height: 'auto'
      },
      content: [
        //header
        {
          columns: [
            {
              // fixed width
              width: "100%",
              alignment: "center",
              fontSize: 25,
              bold: true,
              text: [mainData.TITLE + "\n"],
            },
          ],
        },
        {
          columns: [
            {
              // % width
              width: '100%',
              bold: true,
              fontSize: 15,
              text: [
                'Fecha creación ' + mainData.FI + '\n',
                'Impreso el: ' + mainData.FG + ' ' + mainData.HG + '\n',
              ]
            }
          ],
        },
        {
          columns: [
            {
              // % width
              width: '100%',
              bold: true,
              fontSize: 25,
              text: [
                'Salida: ' + mainData.DS + ' - ' + mainData.AS + '\n',
                'Entrada: ' + mainData.DE + ' - ' + mainData.AE + '\n',
              ]
            }
          ],
        },
        {
          columns: [
            {
              width: "100%",
              table: {
                widths: ['20%', '60%', '20%'],
                heights: 20,
                body: getTable,
              },
            },
          ],
          margin: [0, 0, 0, 80],
        },
        {
          columns: [
            {
              width: "100%",
              table: {
                widths: ['100%'],
                heights: 25,
                body: [[
                  {
                    bold: true,
                    text: "FIRMA RECIBIDO",
                    alignment: "center",
                    border: [false, true, false, false],
                    fontSize: 20,
                    margin: [0, 0, 0, 50],
                  },
                ],[
                  {
                    bold: true,
                    text: "FIRMA ENTREGADO",
                    alignment: "center",
                    border: [false, true, false, false],
                    fontSize: 20,
                    
                  },
                ]],
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },


      ],
    };
    return docDefinition;
  }

  static getTable(data) {
    let headers = [
      {
        text: "Cnt",
        border: [true, true, true, true],
        fontSize: 20,
        alignment: "center",
      },
      {
        text: "Presentación",
        border: [true, true, true, true],
        fontSize: 20,
        alignment: "center",
      },
      {
        text: "Rdm",
        border: [true, true, true, true],
        fontSize: 20,
        alignment: "center",
      },
    ];
    let items = [headers];
    data.forEach((item) => {
      let rowToAdd = [];
      if (item.type == "header") {
        rowToAdd = [
          {
            bold: true,
            text: item.nm,
            border: [true, true, true, true],
            fontSize: 20,
            colSpan: 3,
          },
        ];
      }else{
        rowToAdd = [
          {
            text: item.cn,
            alignment: "center",
            border: [true, false, true, false],
            fontSize: 20,
          },
          {
            text: item.nm ,
            border: [true, false, true, false],
            fontSize: 20,
          },
          {
            text: item.rm + " "+item.um,
            alignment: "center",
            border: [true, false, true,false],
            fontSize: 20,
          },
        ];
      }
      items.push(rowToAdd);
    })
    return items
  }


}
